import React from 'react';
import ReactDOM from 'react-dom';
import Content from './components/Content';
import LoginProvider from '../store/provider/LoginProvider';
import { ILoginProps, IRenderLoginProps } from '../types';
import './index.less';

export function LoginComponent({ ...props }: ILoginProps) {
    return (
        <LoginProvider { ...props }>
            <Content />
        </LoginProvider>
    )
}

export function renderLoginComponent ({ selector, ...props }: IRenderLoginProps) {
    const divContainer = document.createElement('div');
    const renderSelector = document.querySelector(selector)
    if (renderSelector) {
        // eslint-disable-next-line unicorn/prefer-node-append
        renderSelector.appendChild(divContainer);
        ReactDOM.render(
            <LoginComponent { ...props }/>,
            divContainer,
        );
    }
}

